/**
 * ⭐ As opções de uma lista longa, com o título de cada grupo — 27/10/2026 (PRD §65).
 *
 * As listas dele do papel no ato (77 papéis) e da situação patrimonial vêm em
 * grupos, na ordem dele; sem os títulos, achar um item numa lista desse tamanho
 * vira caça.
 *
 * ⚠️ **A lista antiga (`grupo: null`) não se oferece para lançamento novo, e
 * aparece quando é a escolha atual.** Sem isso, abrir um lançamento antigo
 * mostraria a caixa vazia, e gravar apagaria a escolha sem ninguém ter pedido.
 */
export function OpcoesAgrupadas<T extends string>({
  itens,
  atual,
  sufixo,
}: {
  itens: Array<{ chave: T; rotulo: string; grupo: string | null }>;
  atual: T | '' | null;
  sufixo?: (chave: T) => string;
}) {
  const grupos: Array<{ titulo: string; itens: typeof itens }> = [];
  for (const x of itens) {
    if (x.grupo === null) continue;
    const g = grupos.find((y) => y.titulo === x.grupo);
    if (g) g.itens.push(x);
    else grupos.push({ titulo: x.grupo, itens: [x] });
  }
  const antiga = itens.find((x) => x.grupo === null && x.chave === atual);
  const opcao = (x: (typeof itens)[number]) => (
    <option key={x.chave} value={x.chave}>
      {x.rotulo}
      {sufixo ? sufixo(x.chave) : ''}
    </option>
  );
  return (
    <>
      {grupos.map((g) => (
        <optgroup key={g.titulo} label={g.titulo}>
          {g.itens.map(opcao)}
        </optgroup>
      ))}
      {antiga && <optgroup label="Da lista antiga">{opcao(antiga)}</optgroup>}
    </>
  );
}
